export default "__VITE_ASSET__CwTJ95Qz__"